<div [id]="this.field.key" [class]="getIsExecutingRequestClass()">
  @if(this.field.label) {
      <h4 [class]="this.field.labelClassName">{{this.field.label}}</h4>
  }

  <lib-lookup-field [field]="this.field" [form]="form" [class]="this.field.className" />
  <ng-content></ng-content>

  @if(this.field.type !== 'borderless') {
      <mat-divider />
  }
</div>